/**
 * 
 */
import { QuestionaryShort } from './questionaryShort.model';
import { Identity } from '@n3/ng-api-common';
import { EntityState } from '@n3/ng-api-common';
import { ClassifierShort } from '@n3/ng-api-common';
import { Tag } from '@n3/ng-api-common';
export class Questionary extends QuestionaryShort {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public identity: Identity; /**/
    public entity_state: EntityState; /**/
    public name: string; /*Название*/
    public description: string; /*Описание*/
    public level: ClassifierShort; /**/
    public discipline: ClassifierShort; /**/
    public education_stage: ClassifierShort; /**/
    public difficulty: ClassifierShort; /**/
    public event_level: ClassifierShort; /**/
    public tag: Tag; /**/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super(json);

        this.identity = new Identity(json.identity);
        this.entity_state = new EntityState(json.entity_state);
        this.name = json.name || null;
        this.description = json.description || null;
        this.level = new ClassifierShort(json.level);
        this.discipline = new ClassifierShort(json.discipline);
        this.education_stage = new ClassifierShort(json.education_stage);
        this.difficulty = new ClassifierShort(json.difficulty);
        this.event_level = new ClassifierShort(json.event_level);
        this.tag = new Tag(json.tag);
        this._isEmpty = this.isEmpty(this);
    }
}
